export default "__VITE_ASSET__eOwpU1LI__"